var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
import { DatePicker, FieldIconMode } from '../DatePicker';
import { ReadOnlyField } from '../ReadOnlyField';
import { AutosaveField } from './AutosaveField';
var AutosaveDateTimePicker = /** @class */ (function (_super) {
    __extends(AutosaveDateTimePicker, _super);
    function AutosaveDateTimePicker() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderCheckbox = function (fieldProps) {
            var _a = _this.props, onChange = _a.onChange, errorText = _a.errorText, otherProps = __rest(_a, ["onChange", "errorText"]);
            var readOnly = !!_this.props.readOnly;
            var handleChange = function (date) {
                if (readOnly)
                    return;
                if (_this.props.disabled)
                    return;
                if (date) {
                    var adjustedMoment = date.clone().startOf('minute');
                    fieldProps.onChange(adjustedMoment);
                    if (onChange)
                        onChange(adjustedMoment);
                }
                else {
                    fieldProps.onChange(null);
                    if (onChange)
                        onChange(null);
                }
            };
            var handleClear = function () {
                handleChange(null);
            };
            if (readOnly) {
                var time = fieldProps.fieldValue;
                return (React.createElement(ReadOnlyField, { label: otherProps.label }, !!time ? time.format(otherProps.format) : null));
            }
            else {
                var displayErrorText = !!errorText
                    ? errorText
                    : !!fieldProps.error && fieldProps.touched
                        ? fieldProps.error
                        : undefined;
                return (React.createElement(DatePicker, __assign({}, otherProps, { value: fieldProps.fieldValue, onChange: handleChange, calendarIconMode: FieldIconMode.Embed, onClear: handleClear, label: _this.props.label, errorText: displayErrorText, testId: _this.props.testId })));
            }
        };
        return _this;
    }
    AutosaveDateTimePicker.prototype.render = function () {
        return React.createElement(AutosaveField, { field: this.props.field, render: this.renderCheckbox });
    };
    return AutosaveDateTimePicker;
}(Component));
export { AutosaveDateTimePicker };
